/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ priceUnit: NonNullable<unknown>, billingFrequency: NonNullable<unknown> }} Admin_Resource_Form_Product_Rate_DescriptionInputs */

const en_admin_resource_form_product_rate_description = /** @type {(inputs: Admin_Resource_Form_Product_Rate_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.priceUnit}, ${i?.billingFrequency}`)
};

const de_admin_resource_form_product_rate_description = /** @type {(inputs: Admin_Resource_Form_Product_Rate_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.priceUnit}, ${i?.billingFrequency}`)
};

const es_admin_resource_form_product_rate_description = /** @type {(inputs: Admin_Resource_Form_Product_Rate_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.priceUnit}, ${i?.billingFrequency}`)
};

const fr_admin_resource_form_product_rate_description = /** @type {(inputs: Admin_Resource_Form_Product_Rate_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.priceUnit}, ${i?.billingFrequency}`)
};

const nl_admin_resource_form_product_rate_description = /** @type {(inputs: Admin_Resource_Form_Product_Rate_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.priceUnit}, ${i?.billingFrequency}`)
};

/** @type {(inputs: Admin_Resource_Form_Product_Rate_DescriptionInputs) => LocalizedString} */
const it_admin_resource_form_product_rate_description = en_admin_resource_form_product_rate_description;

/** @type {(inputs: Admin_Resource_Form_Product_Rate_DescriptionInputs) => LocalizedString} */
const pt_br2_admin_resource_form_product_rate_description = en_admin_resource_form_product_rate_description;

/** @type {(inputs: Admin_Resource_Form_Product_Rate_DescriptionInputs) => LocalizedString} */
const pl_admin_resource_form_product_rate_description = en_admin_resource_form_product_rate_description;

/** @type {(inputs: Admin_Resource_Form_Product_Rate_DescriptionInputs) => LocalizedString} */
const hu_admin_resource_form_product_rate_description = en_admin_resource_form_product_rate_description;

/** @type {(inputs: Admin_Resource_Form_Product_Rate_DescriptionInputs) => LocalizedString} */
const ro_admin_resource_form_product_rate_description = en_admin_resource_form_product_rate_description;

/**
* | output |
* | --- |
* | "{priceUnit}, {billingFrequency}" |
*
* @param {Admin_Resource_Form_Product_Rate_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_product_rate_description = /** @type {((inputs: Admin_Resource_Form_Product_Rate_DescriptionInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Product_Rate_DescriptionInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_product_rate_description(inputs)
	if (locale === "de") return de_admin_resource_form_product_rate_description(inputs)
	if (locale === "es") return es_admin_resource_form_product_rate_description(inputs)
	if (locale === "fr") return fr_admin_resource_form_product_rate_description(inputs)
	if (locale === "nl") return nl_admin_resource_form_product_rate_description(inputs)
	if (locale === "it") return it_admin_resource_form_product_rate_description(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_product_rate_description(inputs)
	if (locale === "pl") return pl_admin_resource_form_product_rate_description(inputs)
	if (locale === "hu") return hu_admin_resource_form_product_rate_description(inputs)
	return ro_admin_resource_form_product_rate_description(inputs)
});
export { admin_resource_form_product_rate_description as "admin.resource_form.product_rate_description" }